module.exports = __webpack_public_path__ + "2d3a4212337f78b9dabfb395eafdc4f3.png";